import { TActState } from "views/services/banner";
import { MonthsLan } from "./language/texts";

/**
 * 将时间戳转换为日月年 （13 January 2008）
 * @param timeStamp 时间戳
 */
export const formatDate = (timeStamp: number, language: string = "en"): string => {
	const date: Date = new Date(timeStamp);
	const monthArr: string[] = MonthsLan[language] || MonthsLan["en"];
	const year: string = date.getFullYear().toString();
	const month: string = monthArr[date.getMonth()];
	const day: string = date.getDate().toString();

	switch (language) {
		case "es":
		case "pt":
			return `${day} de ${month} de ${year}`;
		default:
			return `${day} ${month} ${year}`;
	}
};

/**
 * 将接口返回的 left 转换为时分秒 （["33", "22", "10"]）
 * @param leftTime 接口返回的 left 字段
 */
export const formatMinutesAndSeconds = (leftTime: number, state: TActState): string[] => {
	if (leftTime > -1) {
		const onlyOnGoing =
			state === TActState.OnGoing ? EnFormateDays(leftTime) * SECONDS_IN_A_DAY : 0;
		const newTime = leftTime - onlyOnGoing;
		const hour: string = Math.floor(newTime / 3600).toString();
		const min: string = (Math.floor(newTime / 60) % 60).toString();
		const sec: string = (newTime % 60).toString();

		return [hour, min, sec].map((item) => {
			if (+item < 10) {
				item = "0" + item;
			}
			return item;
		});
	}
	return [];
};

export const SECONDS_IN_A_DAY = 24 * 60 * 60;

export const EnFormateDays = (sec: number) => {
	if (sec && sec > 0) {
		return Math.floor(sec / SECONDS_IN_A_DAY);
	}
	return 0;
};

export const endUnit = (language: string = "en") => {
	switch (language) {
		case "no":
			return "Dager";
		case "pt":
			return "Dias";
		case "es":
			return "Días";
		case "de":
			return "Tag";
		default:
			return "days";
	}
};

const formatTime = (t: number) => {
	if (t <= 0) {
		return "00";
	}
	return t > 9 ? `${t}` : `0${t}`;
};
// 秒转化为时分秒
export const formatSecToDate = (t: number) => {
	const hour = formatTime(Math.floor(t / 3600));
	const min = formatTime(Math.floor((t / 60) % 60));
	const sec = formatTime(Math.floor(t % 60));
	return `Ends in ${hour}:${min}:${sec}`;
};
